var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefConsumer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29454_43640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7459 41.0387V43.9309L39.8465 48.8122L36.1719 45.1512L41.0713 40.2698L44.7459 41.0387Z",
    fill: "#59C4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1717 45.1512L32.4971 48.8122L27.5977 43.9309V41.0387L31.2722 40.2698L36.1717 45.1512Z",
    fill: "#59C4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3492 72.0003H8V45.1527L27.5978 41.0402V43.9324L32.4972 48.8138L36.1718 45.1527V72.0003H15.3492Z",
    fill: "#DEF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9945 72.0003H36.1719V45.1527L39.8465 48.8138L44.7459 43.9324V41.0402L64.3437 45.1527V72.0003H56.9945Z",
    fill: "#DEF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0713 34.17V40.2717L36.1719 45.1531L31.2725 40.2717V34.17L31.3092 34.0967C32.7423 34.9144 34.3959 35.3903 36.1719 35.3903C37.9479 35.3903 39.6015 34.9144 41.0346 34.0967L41.0713 34.17Z",
    fill: "#FAA68E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3731 20.7461V24.4071C23.6661 24.4071 21.4736 22.2227 21.4736 19.5257C21.4736 18.1833 22.0248 16.963 22.9067 16.0722C23.8009 15.1935 25.0257 14.6443 26.3731 14.6443V20.7461Z",
    fill: "#FFBFAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4371 16.0722C50.319 16.963 50.8701 18.1833 50.8701 19.5257C50.8701 22.2227 48.6776 24.4071 45.9707 24.4071V14.6443C47.318 14.6443 48.5429 15.1935 49.4371 16.0722Z",
    fill: "#FFBFAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6959 30.5088C26.8507 29.081 26.373 27.4091 26.373 25.6274V15.8647L28.8228 13.424H34.9471C38.6216 13.424 39.8465 8.5426 39.8465 8.5426C39.8465 13.424 43.5211 13.424 43.5211 13.424L45.9708 15.8647V25.6274C45.9708 28.3244 44.8684 30.7651 43.1046 32.5346C42.4922 33.1447 41.794 33.6695 41.0346 34.0966C39.6015 34.9142 37.948 35.3902 36.1719 35.3902C34.3959 35.3902 32.7423 34.9142 31.3092 34.0966C29.8027 33.2424 28.5533 32.0098 27.6959 30.5088Z",
    fill: "#FFCDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.42 12.2034V15.8645H45.9703L43.5206 13.4238C43.5206 13.4238 39.846 13.4238 39.846 8.54241C39.846 8.54241 38.6212 13.4238 34.9466 13.4238H28.8223L26.3726 15.8645H23.9229V12.2034C23.9229 5.46714 29.4102 0 36.1714 0C42.9327 0 48.42 5.46714 48.42 12.2034Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29454_43640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefConsumer);
export default __webpack_public_path__ + "static/media/ref-consumer.0dfed481406aa284ade0d36f65e5e1df.svg";
export { ForwardRef as ReactComponent };